import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faEnvelope, faUnlockAlt, faCalculator, faSyncAlt, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faGithub, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { Col, Row, Form, Card, Button, FormCheck, Container, InputGroup, Image } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../../routes";
import AppLogo from "../../assets/img/logo.png";

import { useFormik } from "formik";
import * as Yup from "yup";
import {API_URL, LOGIN} from "../../const";
import axios from "axios";
import { saveLoginSession } from "../../utils/authSession";
import { useNavigate } from 'react-router-dom';

const generateCaptcha = () => {
  const num1 = Math.floor(Math.random() * 10) + 1;
  const num2 = Math.floor(Math.random() * 10) + 1;
  return { num1, num2, answer: num1 + num2 };
};

export default () => {

  const navigate = useNavigate();

  const [captcha, setCaptcha] = React.useState(generateCaptcha);
  const [showPassword, setShowPassword] = React.useState(false);

  const refreshCaptcha = (formik) => {
    setCaptcha(generateCaptcha());
    formik.setFieldValue("captchaAnswer", "");
  };

  const formik = useFormik({
    initialValues: {
      // email: "",
      username: "",
      password: "",
      captchaAnswer: "",
      remember: false,
    },
    validationSchema: Yup.object({
      // email: Yup.string().email("Invalid email address").required("Email is required"),
      username: Yup.string().required("Username is required"),
      password: Yup.string().min(6, "Minimum 6 characters").required("Password is required"),
      captchaAnswer: Yup.number()
        .typeError("Numbers only")
        .required("Please solve the security check"),
    }),
    onSubmit: async(values,{setStatus, setSubmitting, resetForm, setFieldValue}) => {

      if (Number(values.captchaAnswer) !== captcha.answer) {
        setStatus("Incorrect answer to the security check. Please try again.");
        setCaptcha(generateCaptcha());
        setFieldValue("captchaAnswer", "");
        setSubmitting(false);
        return;
      }

      const formData = new FormData();
      // formData.append("email", values.email);
      formData.append("username", values.username);
      formData.append("password", values.password);
        try {

            const response = await axios.post(API_URL + LOGIN, formData);

            if (response.status === 200) {
                // Check response data to determine login success
                if (response.data && response.data.status === true) {

                    // localStorage.setItem('quotetoken', JSON.stringify(response.data.token));
                    // localStorage.setItem('quoteloginusername', JSON.stringify(response.data.admin.name));
                    // localStorage.setItem('quoteadmin', JSON.stringify(response.data.admin));
                    saveLoginSession({ token: response.data.token, admin: response.data.admin });

                    // localStorage.setItem('UserDetail', JSON.stringify(response.data));

                    navigate('/dashboard/overview')

                } else {
                    console.log("Invalid credentials");
                    setStatus(response.data.message || "Invalid credentials");
                    setCaptcha(generateCaptcha());
                    setFieldValue("captchaAnswer", "");
                }
            } else {
                console.log("Unknown error occurred");
            }
        } catch (error) {
          const status = error.response?.status;
          let errorMsg = 'Unable to connect to the API. Start the Laravel server on port 8000 and try again.';

          if (status === 401) {
            errorMsg = error.response?.data?.message || 'Invalid username or password.';
          } else if (status === 404) {
            errorMsg = 'Login API endpoint was not found. Check the backend URL and Laravel routes.';
          } else if (status === 422) {
            errorMsg = error.response?.data?.message || 'Please check the login fields.';
          } else if (status >= 500) {
            errorMsg = 'The API server encountered an error. Check the Laravel logs.';
          } else if (error.response?.data?.message) {
            errorMsg = error.response.data.message;
          }

          setStatus(errorMsg);
          setCaptcha(generateCaptcha());
          setFieldValue("captchaAnswer", "");
        } finally {
            setSubmitting(false)
        }
    }
})

  return (
    <main
      style={{
        minHeight: "100vh",
        backgroundImage: "url(/background.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <section className="d-flex align-items-center min-vh-100 py-5">
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <Image src={AppLogo} height={48} alt="Quote Register" />
                </div>
                <Form className="mt-4" noValidate onSubmit={formik.handleSubmit}>
                  <Form.Group id="username" className="mb-3">
                    {/* <Form.Label>Your Email</Form.Label> */}
                    <Form.Label>Username</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faEnvelope} />
                      </InputGroup.Text>
                      <Form.Control
                        type="username"
                        // placeholder="example@company.com"
                        {...formik.getFieldProps("username")}
                        isInvalid={formik.touched.username && !!formik.errors.username}
                        className="ps-3"
                      />
                    </InputGroup>
                    {formik.touched.username && formik.errors.username && (
                      <div className="text-danger mt-1">{formik.errors.username}</div>
                    )}
                  </Form.Group>

                  <Form.Group controlId="login-password" className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <div className="login-password-field">
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          autoComplete="current-password"
                          {...formik.getFieldProps("password")}
                          isInvalid={formik.touched.password && !!formik.errors.password}
                          className="ps-3"
                        />
                      </InputGroup>
                      <button
                        type="button"
                        className="login-password-toggle"
                        aria-label={showPassword ? "Hide password" : "Show password"}
                        aria-controls="login-password"
                        title={showPassword ? "Hide password" : "Show password"}
                        onMouseDown={event => event.preventDefault()}
                        onClick={() => setShowPassword(visible => !visible)}
                      >
                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} aria-hidden="true" />
                      </button>
                    </div>
                    {formik.touched.password && formik.errors.password && (
                      <div className="text-danger mt-1">{formik.errors.password}</div>
                    )}
                  </Form.Group>

                  <Form.Group id="captchaAnswer" className="mb-3">
                    <Form.Label>Security Check</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faCalculator} />
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        inputMode="numeric"
                        placeholder="Your answer"
                        {...formik.getFieldProps("captchaAnswer")}
                        isInvalid={formik.touched.captchaAnswer && !!formik.errors.captchaAnswer}
                        className="ps-3"
                      />
                      <Button
                        variant="outline-secondary"
                        type="button"
                        className="rounded-end"
                        title="Get a new question"
                        onClick={() => refreshCaptcha(formik)}
                      >
                        <FontAwesomeIcon icon={faSyncAlt} />
                      </Button>
                    </InputGroup>
                    <Form.Text className="text-slate-gray">
                      What is {captcha.num1} + {captcha.num2}?
                    </Form.Text>
                    {formik.touched.captchaAnswer && formik.errors.captchaAnswer && (
                      <div className="text-danger mt-1">{formik.errors.captchaAnswer}</div>
                    )}
                  </Form.Group>

                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <Form.Check type="checkbox">
                      <FormCheck.Input
                        id="remember"
                        className="me-2"
                        checked={formik.values.remember}
                        onChange={formik.handleChange}
                      />
                      <FormCheck.Label htmlFor="remember" className="mb-0 font-500 text-slate-gray">
                        Remember me
                      </FormCheck.Label>
                    </Form.Check>
                  </div>

                  <Button variant="primary" type="submit" className="w-100 btn-quote-blue text-uppercase">
                    login
                  </Button>
                  {formik.status && (
                    <div className="mt-3 w-full px-4 py-2 text-left rounded text-xs text-[#b0233a] bg-[#fae5e9] alert alert-danger show-message-block">
                      <p className="mb-0">
                        <i className="ri-close-circle-fill mr-1"></i> {formik.status}
                      </p>
                    </div>
                  )}
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};